import axios from "axios";

export default {
    state: {
        lands: [],
        filter: {}
    },
    getters: {
        LANDS: state => {
            return state.lands;
        },
        LANDS_FILTER: state => {
            return state.filter;
        }
    },
    mutations: {
        SET_LANDS: (state, payload) => {
            state.lands = payload;
        },
    },
    actions: {
        GET_LANDS: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios
                  .get(`lands`)
                  .then(({ data, status }) => {
                    if (status === 200) {
                        commit("SET_LANDS", data);
                        resolve(true);
                    }
                  })
                  .catch(error => {
                    reject(error);
                });
            });
        },
    }
}